import React, { createContext, useContext } from 'react';
import { useLogin } from './hooks/useLogin';

const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
  const loginData = useLogin();
  
  return (
    <LoginContext.Provider value={loginData}>
      {children}
    </LoginContext.Provider>
  );
};

export const useLoginContext = () => {
  const context = useContext(LoginContext);
  if (!context) {
    throw new Error('useLoginContext must be used within a LoginProvider');
  }
  return context;
};